// extracted by mini-css-extract-plugin
export default {"headingCard":"HeadingComponent_headingCard__Ls0cF","headingCardMarkdown":"HeadingComponent_headingCardMarkdown__JDKV9","container":"HeadingComponent_container__qnhrj"};